//https://stackoverflow.com/questions/74338074/how-do-i-properly-integrate-angular-material-datepicker-range-in-formly

import { MatInputModule } from '@angular/material/input';
import {MatDatepicker, MatDatepickerModule} from '@angular/material/datepicker';
import { Component, OnInit, Type, inject } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps, FormlyModule } from '@ngx-formly/core';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ComponentType } from '@angular/cdk/portal';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

interface DatepickerProps extends FormlyFieldProps {
    datepickerOptions?: Partial<{
      touchUi: boolean;
      opened: boolean;
      disabled: boolean;
      startView: 'month' | 'year' | 'multi-year';
      datepickerTogglePosition: 'suffix' | 'prefix';
      calendarHeaderComponent: ComponentType<any>;
      filter: (date: any | null) => boolean;
      min: any;
      max: any;
      dateInput: (field: FieldTypeConfig<DatepickerProps>, event: any) => void;
      dateChange: (field: FieldTypeConfig<DatepickerProps>, event: any) => void;

      monthSelected: (field: FieldTypeConfig<DatepickerProps>, event: any, picker: MatDatepicker<any>) => void;
      yearSelected: (field: FieldTypeConfig<DatepickerProps>, event: any, picker: MatDatepicker<any>) => void;

      panelClass: string | string[];
      startAt: any | null;
    }>;
  }

export interface FormlyDatepickerFieldConfig extends FormlyFieldConfig<DatepickerProps> {
    type: 'mat-daterangepicker' | Type<MatDateRangePickerTypeComponent>;
}



@Component({
    selector: 'app-formly-datepicker-range-type',
    template: `
        @if (formState.editMode) {
        <mat-form-field>
        <mat-label>{{props.label}}</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [dateFilter]="dateFilter">
            <input matStartDate formControlName="dal" />
            <input matEndDate formControlName="al" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker [startAt]="props.datepickerOptions.startAt" >
            <mat-date-range-picker-actions >
                <button mat-button matDateRangePickerCancel>Annulla</button>
                <button mat-raised-button matDateRangePickerApply class="ml-5">Applica</button>
            </mat-date-range-picker-actions>
        </mat-date-range-picker>
        <mat-error *ngIf="range.controls.dal.hasError('matDatepickerParse')">Formato data non valido</mat-error>
        <mat-error *ngIf="range.controls.dal.hasError('min')">La data deve essere dopo {{ props.datepickerOptions.min | date:'dd/MM/yyyy' }}</mat-error>
        <mat-error *ngIf="range.controls.dal.hasError('max')">La data deve essere prima di {{ props.datepickerOptions.max | date:'dd/MM/yyyy' }}</mat-error>
        <mat-error *ngIf="range.controls.dal.hasError('required')">Campo obbligatorio</mat-error>
        </mat-form-field>
        }@else{
        <p>{{field.formControl.value.dal | date:'dd/MM/yyyy'}}</p>
        <p>{{field.formControl.value.al | date:'dd/MM/yyyy'}}</p>

        }


    `,
    standalone: true,
    imports: [
        MatDatepickerModule,
        MatNativeDateModule,
        FormlyModule,
        MatInputModule,
        ReactiveFormsModule,
        DatePipe,
        MatFormFieldModule,
        NgIf
    ],
})
export class MatDateRangePickerTypeComponent extends  FieldType<FieldTypeConfig<DatepickerProps>> {

    override defaultOptions = {
        props: {
          datepickerOptions: {
            startView: 'month' as const,
            datepickerTogglePosition: 'suffix' as const,
            disabled: false,
            opened: false,
            dateInput: () => {},
            dateChange: () => {},
            monthSelected: () => {},
            yearSelected: () => {}
          },
        },
      };



  get shouldLabelFloat(): boolean {
    return this.focused || !this.empty;
  }



  range = new FormGroup({
    dal: new FormControl<Date | null>(null, [
      Validators.required,
      Validators.min(this.field.props?.datepickerOptions?.min ? new Date(this.field.props.datepickerOptions.min).getTime() : 0),
      Validators.max(this.field.props?.datepickerOptions?.max ? new Date(this.field.props.datepickerOptions.max).getTime() : Number.MAX_VALUE),
    ]),
    al: new FormControl<Date | null>(null, [
      Validators.required,
      Validators.min(this.field.props?.datepickerOptions?.min ? new Date(this.field.props.datepickerOptions.min).getTime() : 0),
      Validators.max(this.field.props?.datepickerOptions?.max ? new Date(this.field.props.datepickerOptions.max).getTime() : Number.MAX_VALUE),
    ]),
  });
    constructor() {
        super();
        this.range.valueChanges.subscribe((v) => {
            this.formControl.setValue(v);
            //this.range.controls.dal.updateValueAndValidity();
            //this.range.controls.al.updateValueAndValidity();
        });

    }

    dateFilter = (date: Date | null): boolean => {
        if (!date) return false;
        return date >= this.field.props.datepickerOptions.startAt; // Filtro: non permette date passate
    };



}

